import React from "react";
import { Box } from "@mui/material";
import { Check } from "lucide-react";

export const CircleUnchecked = () => (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      border: "2px solid hsl(140 8% 88%)",
      boxSizing: "border-box",
      transition: "border-color 200ms",
    }}
  />
);

export const CircleChecked = () => (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      backgroundColor: "hsl(150 38% 17%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
      transition: "all 200ms",
    }}
  >
    <Check size={12} strokeWidth={3} color="hsl(80 97% 72%)" />
  </Box>
);
